import {ArrowBackIos, Close} from '@mui/icons-material';
import {IconButton, Menu, Stack, Typography} from '@mui/material';
import {SidebarDialog} from '@ui/SidebarDialog/SidebarDialog';
import {useTranslation} from 'react-i18next';
import {useDeviceInfo} from 'utils/hooks/useDeviceInfo';

type ReportDownloadManagerWrapperProps = {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    children: React.ReactNode;
};

export const ReportDownloadManagerWrapper = ({
    anchorEl,
    onClose,
    children,
}: ReportDownloadManagerWrapperProps) => {
    const {isMobile} = useDeviceInfo();

    const {t} = useTranslation('npvAnalytics');

    if (isMobile) {
        return (
            <SidebarDialog
                open={Boolean(anchorEl)}
                onClose={onClose}
                customTitleBlock={
                    <Stack
                        direction='row'
                        gap='6px'
                        alignItems='center'
                    >
                        <IconButton onClick={onClose}>
                            <ArrowBackIos />
                        </IconButton>
                        <Typography variant='h4'>
                            {t('repDownloadManager.repGenerationAndUpload')}
                        </Typography>
                    </Stack>
                }
            >
                {children}
            </SidebarDialog>
        );
    }

    return (
        <Menu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            slotProps={{
                paper: {
                    variant: 'outlined',
                    elevation: 2,
                    sx: {width: '400px'},
                },
            }}
        >
            <Stack
                direction='row'
                alignItems='center'
                gap={1}
                justifyContent='space-between'
                sx={{
                    width: '100%',
                    padding: '8px 16px',
                }}
            >
                <Typography>{t('repDownloadManager.repGenerationAndUpload')}</Typography>
                <IconButton
                    onClick={onClose}
                    size='small'
                >
                    <Close />
                </IconButton>
            </Stack>
            {children}
        </Menu>
    );
};
